// Keep the order
export var UserRole;
(function (UserRole) {
    UserRole[UserRole["ADMINISTRATOR"] = 0] = "ADMINISTRATOR";
    UserRole[UserRole["MODERATOR"] = 1] = "MODERATOR";
    UserRole[UserRole["USER"] = 2] = "USER";
})(UserRole || (UserRole = {}));
